export const maintenanceSettingsResourceName = 'MaintenanceSettings';
export const maintenanceSettingsShowPath = `/admin/${maintenanceSettingsResourceName}`;
export const maintenanceSettingsEditPath = `${maintenanceSettingsShowPath}/edit`;
